import { all, call, put, takeLatest } from "redux-saga/effects";
import { getLogsFailed, getLogsSuccess, deleteLogFailed, deleteLogSuccess } from "./logSlice";
import { showErrorToaster, showSuccessToaster } from "../../helpers/utils/toaster";
import logService from "../../services/log.service";

function* logWatcher() {
  yield takeLatest("log/getLogs", getLogsSaga);
  yield takeLatest("log/deleteLog", deleteLogSaga);
}

function* getLogsSaga(action) {
  try {
    const response = yield call(logService.getLogs, action.payload);

    if (response.status) {
      yield put(getLogsSuccess(response.data));
    } else {
      yield put(getLogsFailed(response.message));
    }
  } catch (err) {
    console.log("Error: ", err);
    yield put(getLogsFailed("Internal service error!"));
  }
}

function* deleteLogSaga(action) {
  try {
    const response = yield call(logService.deleteLog, action.payload);

    if (response.status) {
      yield put(deleteLogSuccess(action.payload));
      showSuccessToaster(response.message);
    } else {
      yield put(deleteLogFailed(response.message));
      showErrorToaster(response.message);
    }
  } catch (err) {
    console.log("Error: ", err);
    yield put(getLogsFailed("Internal service error!"));
  }
}

export default function* logSaga() {
  yield all([logWatcher()]);
}
